// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageHeader___Dzebs{margin-top:32px;margin-bottom:24px;font-size:32px;text-align:center;color:var(--gray600)}\n", "",{"version":3,"sources":["webpack://./src/components/RulesBulkUpload/Title/Title.css"],"names":[],"mappings":"AAAA,oBACI,eAAA,CACA,kBAAA,CACA,cAAA,CACA,iBAAA,CACA,oBAAA","sourcesContent":[".pageHeader {\n    margin-top: 32px;\n    margin-bottom: 24px;\n    font-size: 32px;\n    text-align: center;\n    color: var(--gray600);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": "pageHeader___Dzebs"
};
export default ___CSS_LOADER_EXPORT___;
